import { useIntl } from "react-intl";
import Seo from "../../components/Seo";
import { NewsSearch } from "../../containers/Articles/Search";

export default function Page() {
  const intl = useIntl();

  return (
    <>
      <Seo
        title={intl.formatMessage({ defaultMessage: "Actualités" })}
        description={intl.formatMessage({
          defaultMessage: "Suivez notre actualité",
        })}
      />

      <NewsSearch />
    </>
  );
}
